
import { importSync as i } from '@embroider/macros';
let d = window.define;
import "@ember/test-waiters/-embroider-implicit-modules.js";
import "ember-auto-import/-embroider-implicit-modules.js";
import "ember-cli-typescript/-embroider-implicit-modules.js";
import "ember-destroyable-polyfill/-embroider-implicit-modules.js";
